import { render, staticRenderFns } from "./ListTableClaim.vue?vue&type=template&id=d293cf32&scoped=true&"
import script from "./ListTableClaim.vue?vue&type=script&lang=js&"
export * from "./ListTableClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d293cf32",
  null
  
)

export default component.exports